module.exports = __webpack_public_path__ + "quickbooks_logo.b353a099c6b36169ed22e29c444f36d0.png";